import { useI18n } from '../../i18n';

/** Skeleton block (§5.12): surface-2, opacity-pulse shimmer, static under reduced-motion. */
export function Skeleton({ className = '' }: { className?: string }) {
  return <div className={`skeleton rounded-sm ${className}`} aria-hidden />;
}

/** Card-shaped skeleton mirroring the asset/listing card layout (thumb + 2 rows + chip). */
export function CardSkeleton() {
  // The screen-reader label was hardcoded Spanish while D-009 makes en-US the
  // default — assistive tech announced the wrong language. Read it from i18n.
  const { t } = useI18n();
  return (
    <div className="rounded border border-border-strong bg-surface-2 p-3">
      <Skeleton className="mb-3 h-12 w-full" />
      <Skeleton className="mb-2 h-4 w-3/4" />
      <Skeleton className="mb-3 h-3 w-1/2" />
      <Skeleton className="h-6 w-20" />
      <span className="sr-only">{t.common.loading}</span>
    </div>
  );
}

export function SkeletonGrid({ count = 6 }: { count?: number }) {
  return (
    <div className="grid gap-4 grid-cols-[repeat(auto-fill,minmax(240px,1fr))]" aria-hidden>
      {Array.from({ length: count }, (_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  );
}
